import { isNumber } from 'es-toolkit/compat'

export default isNumber
